// libraries
import { Modal } from '@interstate/components/Modal';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { Typography } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';

const ReloadModal = ({ reloadMessage, reloadSource }: { reloadMessage: string; reloadSource: string }) => {
    const isMobileScreen = useMediaQuery({ query: `(max-width: ${BreakPoint.PHONE})` });
    return (
        <Modal
            header={
                <Typography
                    variant="h4"
                    style={{
                        fontWeight: 'bold',
                        fontSize: '2rem'
                    }}
                    data-testid="reload-modal-header"
                >
                    Updates from {reloadSource}
                </Typography>
            }
            footer={{
                primary: {
                    buttonStyle: 'primary',
                    action: () => {
                        window.location.reload();
                    },
                    label: 'Reload'
                }
            }}
            show={true}
            size={isMobileScreen ? 'small' : 'large'}
            sx={{
                '[data-testid="ids-modal-close-button-reload-modal"]': {
                    display: 'none'
                }
            }}
            data-testid="reload-modal"
        >
            {reloadMessage}
        </Modal>
    );
};

export default ReloadModal;
